<template>
  <div class="changeFishery" >
    <div class="changeFishery-title">
       <h3>欢迎使用渔管理系统</h3>
       <h4 @click="intoYlwIndex">返回首页</h4>
    </div>
   <div class="changeFishery-line"></div>
   <div class="changeFishery-content">
     <div class="right">
        <h3 @click="createFishery">创建渔场</h3>
        <p>提示：须填写渔场名称、地址、负责人信息</p>
     </div>
     <div class="left">
       <h3 @click="intoFishGround">进入演示渔场</h3>
       <p>提示：可在演示渔场进行操作体验；进入<br/>
         演示渔场后，仍可在单位切换处选<br/>
         择创建渔场；</p>
     </div>
   </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../store";
import url from "@/service/base-url";
export default {
  name: "changeFishery",
  data() {
    return {
      reload: "11"
    };
  },
  async mounted() {},
  computed: {},
  methods: {
    ...mapActions(modules.user, {
      getYanShiFishery: "getYanShiFishery"
    }),
    //返回渔联网官网首页
    intoYlwIndex() {
      window.location.href = url.ylwUrl;
    },
    //进入创建渔场
    createFishery() {
      this.$router.push({
        name: "CreateFishery"
      });
    },
    //进入演示渔场
    async intoFishGround() {
      await this.getYanShiFishery()
        .then(() => {
          this.$router.push({
            name: "home",
            params: {
              reload: this.reload
            }
          });
        })
        .catch(err => {});
    }
  }
};
</script>
<style lang="stylus">
.changeFishery{
  width:1000px;
  height:660px;
  background:rgba(255,255,255,1);
  border-radius:10px;
  position :absolute;
  top:0;
  bottom:0;
  left:0;
  right:0;
  margin:auto;
  overflow :hidden;
  ::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    font-size :16px;
    color:B0B0B0;
  }
}
.changeFishery-title{
  display:flex;
  justify-content:space-between;
  font-size:28px;
  font-family:MicrosoftYaHei;
  font-weight:400;
  margin:34px 60px;
  color:rgba(30,114,230,1);
  h4{
    cursor:pointer;
    font-size:16px;
    margin-top:10px;
  }
}
.changeFishery-line{
  margin:0 60px;
  height:1px;
  background:rgba(221,221,221,1);
}
.changeFishery-content{
  display:flex;
  justify-content:space-between;
  margin:35px 60px;
  .left{
    width:400px;
    height:464px;
    background:url("../../assets/images/img_fisheries_bg_1.png")
    position relative;
    h3{
      cursor:pointer;
      position:absolute;
      top:64%;
      text-align: center;
      left:32.2%;
      font-size:24px;
      font-family:MicrosoftYaHeiUI-Bold;
      font-weight:bold;
      text-decoration:underline;
      color:rgba(255,255,255,1);
    }
    p{
      position:absolute;
      top:75%;
      text-align: center;
      left:14%;
      margin:0 auto;
      line-height:30px;
      font-size:16px;
      font-family:MicrosoftYaHei;
      color:rgba(200,220,255,1);
    }
  }
  .right{
    width:400px;
    height:464px;
    background:url("../../assets/images/img_fisheries_bg_2.png");
    position:relative;
     h3{
      cursor:pointer;
      position:absolute;
      top:64%;
      text-align: center;
      left:32.2%;
      font-size:24px;
      font-family:MicrosoftYaHeiUI-Bold;
      font-weight:bold;
      text-decoration:underline;
      color:rgba(255,255,255,1);
    }
    p{
      position:absolute;
      top:75%;
      text-align: center;
      left:12%;
      margin:0 auto;
      line-height:30px;
      font-size:16px;
      font-family:MicrosoftYaHei;
      color:rgba(200,220,255,1);
    }
  }
}

</style>

<style lang="stylus" scoped>

</style>
